<div class="graph-content">
  <div class="modal-layout">
    <div class="chart-section">

      @if (chartType === 'line') {
        <app-svg-chart
          [chartData]="chartData"
          [config]="chartConfig"
          [isLoading]="isLoading"
          [noDataMessage]="errorMessage || ('NO_CHART_DATA' | translate)"
        />
      }

      @if (chartType === 'bar') {
        <msf-p-chart
          [chartData]="chartData"
          [config]="chartConfig"
          [isLoading]="isLoading"
          [noDataMessage]="errorMessage || ('NO_CHART_DATA' | translate)"
        />
      }
    </div>

    <div class="controls-section">
      <div class="chart-controls">
        <div class="control-group">
          <label>{{ 'CHART_TYPE' | translate }}</label>
          <msf-select
            [(model)]="chartType"
            [options]="chartTypeOptions"
            [optionLabel]="'label'"
            [optionValue]="'value'"
            translateBy="locale"
            [width]="'100%'"
          ></msf-select>
        </div>
        <div class="control-group">
          <label>{{ 'DATA_SOURCE' | translate }}</label>
          <msf-select
            [(model)]="selectedDataSource"
            (selectItem)="onDataSourceChange()"
            [options]="dataSourceOptions"
            [optionLabel]="'names'"
            [optionValue]="'id'"
            [width]="'100%'"
          ></msf-select>
        </div>

        <div class="control-group">
          <label>{{ 'WEATHER_INDICATOR' | translate }}</label>
          <msf-multi-select
            translateBy="locale"
            [(model)]="selectedIndicators"
            [options]="indicatorsOptions"
            [optionLabel]="'label'"
            [optionValue]="'value'"
            [placeholder]="'WEATHER_INDICATOR' | translate"
            [showClear]="true"
            [width]="'100%'"
            (selectItem)="onIndicatorChanges()"
            [maxSelectedLabels]="1"
            [maxSelectedItems]="2"
          ></msf-multi-select>
        </div>

        <div class="control-group">
          <label>{{ 'PERIOD' | translate }}</label>
          <app-year-multi-picker
            [(ngModel)]="selectedYears"
            (onYearsChange)="onYearsChange($event)"
            [placeholder]="'SELECT_YEAR_FOR_COMPARE' | translate"
            [maxYears]="5"
            [showIcon]="true">
          </app-year-multi-picker>
        </div>
      </div>
    </div>
  </div>
</div>
